import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=28a120a4"
import script from "./LoginPage.js?vue&type=script&lang=js&external"
export * from "./LoginPage.js?vue&type=script&lang=js&external"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=28a120a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports